import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=630c6cee&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=630c6cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630c6cee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('630c6cee')) {
      api.createRecord('630c6cee', component.options)
    } else {
      api.reload('630c6cee', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=630c6cee&scoped=true&", function () {
      api.rerender('630c6cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pvE3tCw0uXYr/JS/comp/PopupDialog.vue"
export default component.exports